"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Information from foundation/Information
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Information = createSVGIcon(
  <path
    d="M12 8.267a.533.533 0 0 0-.533.533v.167a.533.533 0 0 0 1.066 0V8.8A.533.533 0 0 0 12 8.267m0 2.133a.533.533 0 0 0-.533.533V15.2a.533.533 0 0 0 1.066 0v-4.267A.533.533 0 0 0 12 10.4m0 8.533c-3.822 0-6.933-3.11-6.933-6.933S8.177 5.067 12 5.067s6.933 3.11 6.933 6.933-3.11 6.933-6.933 6.933M12 4a8.01 8.01 0 0 0-8 8c0 4.412 3.588 8 8 8s8-3.588 8-8-3.588-8-8-8"
    fill="currentColor"
  />,
  "Information",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Information",
    fill: "none",
    className: legacyIconCls(),
  }
);
